import React from 'react';

export default function Button({
  children,
  variant = "primary",
  size = "md",
  className = "",
  ...props
}) {
  const base =
    "inline-flex items-center justify-center font-bold tracking-tight rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500/50 focus:ring-offset-[#050505] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed";

  const variants = {
    // Premium Orange Gradient
    primary: "bg-gradient-to-br from-orange-500 to-red-600 text-white shadow-lg shadow-orange-500/20 hover:shadow-orange-500/40 hover:brightness-110",
    
    // Glassmorphism Outline
    outline: "border border-white/10 text-white hover:bg-white/5 hover:border-white/20",
    
    // High-Contrast Light
    secondary: "bg-white text-black hover:bg-gray-200 shadow-xl shadow-white/5",
    
    // Ghost variant for subtle actions
    ghost: "text-gray-400 hover:text-white hover:bg-white/5",
  };

  const sizes = {
    sm: "px-4 py-3 text-xs uppercase tracking-widest",
    md: "px-6 py-3 text-sm",
    lg: "px-8 py-4 text-base",
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}